var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7280_38805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1738 12C16.1738 13.0435 14.3051 15.6522 11.9999 15.6522C9.69477 15.6522 7.82605 13.0435 7.82605 12C7.82605 9.69478 9.69477 7.82611 11.9999 7.82611C14.3051 7.82611 16.1738 9.69478 16.1738 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1738 12C16.1738 14.3052 14.3051 16.1739 11.9999 16.1739C9.69477 16.1739 7.82605 14.3052 7.82605 12",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4238 15.6894L17.5304 14.5828L18.2682 15.3206L17.1616 16.4272L16.4238 15.6894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.579 17.5338L15.6856 16.4272L16.4233 17.165L15.3167 18.2716L14.579 17.5338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6372 17.9025L19.7438 16.7959L20.4815 17.5337L19.375 18.6403L18.6372 17.9025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7924 19.7472L17.899 18.6406L18.6367 19.3784L17.5301 20.485L16.7924 19.7472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5304 16.7961L18.637 15.6895L19.3747 16.4272L18.2681 17.5338L17.5304 16.7961Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.686 18.6404L16.7926 17.5339L17.5304 18.2716L16.4238 19.3782L15.686 18.6404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6421 8.31259L15.6911 5.36165L16.4289 4.62391L19.3798 7.57485L18.6421 8.31259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6906 7.57515L14.584 6.46855L15.3217 5.73084L16.4283 6.83744L15.6906 7.57515Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5349 9.41994L16.4283 8.31335L17.166 7.57564L18.2726 8.68223L17.5349 9.41994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9036 5.36155L16.797 4.25495L17.5347 3.51721L18.6413 4.62381L17.9036 5.36155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7489 7.20658L18.6423 6.09998L19.38 5.36224L20.4866 6.46883L19.7489 7.20658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25415 16.794L7.20509 19.7449L6.46735 20.4827L3.51641 17.5317L4.25415 16.794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20496 17.5312L8.31155 18.6378L7.57384 19.3755L6.46725 18.2689L7.20496 17.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36035 15.6872L6.46695 16.7938L5.72921 17.5315L4.62261 16.4249L5.36035 15.6872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46716 14.5802L9.4181 17.5312L8.68036 18.2689L5.72942 15.318L6.46716 14.5802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20471 4.25267L4.25377 7.20361L3.51603 6.46586L6.46697 3.51492L7.20471 4.25267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3114 5.35915L5.36046 8.31009L4.62272 7.57234L7.57366 4.6214L8.3114 5.35915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41895 6.46642L6.468 9.41736L5.73029 8.67965L8.68123 5.72871L9.41895 6.46642Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7280_38805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.6bb06062fc3a0fbd5c976eb9da33fff8.svg";
export { ForwardRef as ReactComponent };